/**
 * Prefix the time to logs for monitoring long-running operations
 * 
 * Do not use it everywhere since the browser won't show the file name and line number anymore
 * 
 * @param args Args given to `console.log`
 */
export default (...args) => {
  const current_date = new Date();
  const log_date = `${current_date.toLocaleTimeString()} (${current_date.getMilliseconds()}ms)`;

  // let log_args = chalk.white(...args);

  // console.log(`${log_date} |`, require('util').inspect(...args, {colors: true, depth: null}));
  console.log(`${log_date} |`, ...args);
};
